"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fileAggregate = void 0;
const flattenDeep_1 = __importDefault(require("lodash-es/flattenDeep"));
const field_logic_1 = require("../field-type-registry/field-logic");
function fileAggregate(aggregate) {
    // TODO: The Lookup field uses this aggregations without modifications. It is necessary to
    //  rewrite receiving aggregations through a function as receiving filtering functions (getComparisons).
    //  Move logic flatten to Lookup field logic
    return (0, field_logic_1.valuesAggregator)((values) => aggregate((0, flattenDeep_1.default)(values)));
}
exports.fileAggregate = fileAggregate;
